<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    max-width="900px"
    :save-menu-list="[SAVE]"
    :action-save="onSave"
    @closed="$emit('closed')"
  >
    <template #title-text>
      Выбрать год
    </template>

    <template #default>
      <v-select
        v-model="year"
        :items="years"
        outlined
      />
    </template>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import moment from 'moment'

const SAVE = {
  name: 'save',
  label: 'Отправить',
}

export default {
  name: 'PublicationMunMehModal',
  components: {
    BModalForm,
  },
  inheritAttrs: false,
  data: () => ({
    SAVE,
    year: moment().format('YYYY'),
  }),
  computed: {
    years() {
      const max = +moment().format('YYYY')
      const min = 1900
      return Array.from({ length: max - min + 1 }, (v, i) => (min + i).toString()).reverse()
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    transformData(data) {
      return data
    },
    onSave() {
      this.$emit('ready', +this.year)
      this.close()
    },
  },
}
</script>
